import { render, staticRenderFns } from "./ClaimViewSwitchingState.vue?vue&type=template&id=4d2c30f0&scoped=true&lang=pug&"
import script from "./ClaimViewSwitchingState.vue?vue&type=script&lang=js&"
export * from "./ClaimViewSwitchingState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2c30f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
